document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('shea-kukui');
  if (!root) return;

  root.classList.remove('presale');

  const show = (selector) => root.querySelectorAll(selector).forEach((element) => element.classList.add('show'));
  setTimeout(() => {
    show('#opening');
    setTimeout(() => {
      show('.hero-wrapper, .anim-nuts .nuts1, .anim-nuts .nuts2, .heroTitle, .heroCopy');
      setTimeout(() => {
        root.querySelectorAll('.anim-nuts .nuts1, .anim-nuts .nuts2').forEach((element) => element.classList.add('on'));
        root.querySelector('#opening')?.remove();
      }, 1600);
    }, 600);
  }, 600);

  const animatedElements = root.querySelectorAll('.js-anim-scroll');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('inview');
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    animatedElements.forEach((element) => observer.observe(element));
  } else {
    animatedElements.forEach((element) => element.classList.add('inview'));
  }

  root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = root.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
